<template src='./ArrobaMedellinVerticalCardIdi.html'></template>

<script>
export default {
  props: {
    img: { type: String },
    imgDescription: { type: String, default: "Imagen" },
    title: { type: String },
    subtitle: { type: String },
    body: { type: [String, Object], required: false },
    progress: { type: [Number, String]},
    typeCard: { type: Object },
    url: { type: String },
    person: { type: Number, required: false},
    buttonText: { type: String }
  },
  name: 'arroba-medellin-vertical-card-idi',
  methods: {
    pushButton() {
      this.$emit('verticalCardClickButton')
    },
  },
  computed: {
    imgUrl() {
      return this.img ? this.img : 'https://storage.googleapis.com/arrobamedellin.appspot.com/Img_default.png';
    }
  }
}
</script>

<style lang="scss" scoped src="./ArrobaMedellinVerticalCardIdi.scss"></style>
